import { CommandAction } from "src/app/abstract/command/command-action.service";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";
import { Injectable } from "@angular/core";
import { WidgetsService } from "../widgets/widgets.service";
import { Logger } from "src/app/core/logger";
import { WidgetsTimeRangeModel } from "../../models/widgets/widgets-time-range.model";
import { WidgetsSelectionService } from "../widgets/widgets-selection.service";

@Injectable()
export class CommandTimeRangeService extends CommandAction {
  constructor(
    private widgetsService: WidgetsService,
    private selectionService: WidgetsSelectionService,
    private logger: Logger) {
    super();
  }

  public execute(parent: WidgetsAbstract, widget: WidgetsAbstract): WidgetsTimeRangeModel {
    const newWidget = new WidgetsTimeRangeModel();
    newWidget.parentId = parent.id;
    newWidget.type = "timeRange";
    newWidget.key = this.widgetsService.getNextKey(newWidget.type);

    // A new Primitive borns selected
    this.selectionService.select(newWidget);
    return newWidget;
  }
}
